/* src/views/logements/FicheLingeCtrl.jsx — L'ONGLET « Linge » de la fiche
   logement (lot 4, 2026-08-28). Consigne Dimitri : la dotation attend sa
   table — L'ÉCRAN DIT SON ÉTAT, IL N'INVENTE RIEN. Aucun chiffre tant que
   la table n'existe pas ; les tarifs des articles (linge_prix, en prod)
   auront leur éditeur dans Réglages · Produits (c'est déjà au prototype). */

export default function FicheLingeCtrl() {
  return (
    <>
      <div className="info">Ce compte n'est visible que par <b>vous et
        l'orchestrateur</b>. Ni le propriétaire ni l'agent n'y ont accès.</div>
      <div className="carte" style={{ textAlign: 'center', padding: '24px 16px' }}
        data-testid="linge-etat-attente">
        <p style={{ fontSize: '15px', margin: '0 0 8px' }}>🧺</p>
        <p style={{ fontSize: '12.5px', fontWeight: '600', color: 'var(--navy-d)',
          margin: '0 0 6px' }}>La dotation n'a pas encore sa table</p>
        <p style={{ fontSize: '11.5px', color: 'var(--gris)', margin: '0',
          lineHeight: '1.6', maxWidth: '420px', marginLeft: 'auto',
          marginRight: 'auto' }}>
          Cet écran comptera le linge du logement : ce qui est en place, ce qui
          attend un retour, ce qui est irrécupérable — nourri par les incidents
          que déclare l'agent. La dotation se saisira une fois, puis bougera
          toute seule au rythme des incidents.</p>
      </div>
      <div className="carte" style={{ margin: '0' }}>
        <p style={{ fontSize: '11.5px', color: 'var(--gris)', margin: '0',
          lineHeight: '1.6' }}>
          En attendant : les incidents de linge se déclarent et se jugent dans{' '}
          <b style={{ color: 'var(--navy-d)' }}>Aujourd'hui · Incidents</b>, et
          leurs tarifs (le barème <code style={{ fontSize: '10.5px' }}>linge_prix</code>,
          déjà en production) auront leur éditeur dans{' '}
          <b style={{ color: 'var(--navy-d)' }}>Réglages · Produits</b>.</p>
      </div>
    </>
  )
}
